module.exports = {"#/overview":"/account/overview","#/overview/invite":"/account/invite","#/overview/team":"/account/team","#/overview/billing":"/account/billing","#/overview/member":"/account/overview","#/downgrade":"/downgrade","#/renew":"/renew","#/payment":"/payment","#/login":"/login","#/signup":"/signup","#/create":"/create","#/billing":"/billing","#/join":"/join","#/invalid-invite":"/invalid-invite"}


//////////////////
// WEBPACK FOOTER
// ./src/data/redirects.json
// module id = F6ih
// module chunks = 12